import LostYearsClaims from 'pages/lost-years-claims/LostYearsClaims.vue';
import ClaimantDetails from 'pages/lost-years-claims/steps/ClaimantDetails.vue';
import ClaimInfo from 'pages/lost-years-claims/steps/ClaimInfo.vue';
import IncomeInformation from 'pages/lost-years-claims/steps/IncomeInformation.vue';
import LossOfIncome from 'pages/lost-years-claims/steps/LossOfIncome.vue';
import HeadsOfLoss from 'pages/lost-years-claims/steps/HeadsOfLoss.vue';
import CruBenefits from 'pages/lost-years-claims/steps/CruBenefits.vue';
import InterimPayments from 'pages/lost-years-claims/steps/InterimPayments.vue';
import CalculateLoss from 'pages/lost-years-claims/steps/CalculateLoss.vue';
import Documents from 'components/documents/Documents.vue';
import DocumentEditor from 'components/documents/DocumentEditor.vue';
import DocumentList from 'components/documents/DocumentList.vue';
import {beforeEnter} from 'services/routingMethods';

export default [
    {
        name: 'lost',
        path: '/lost-years/:id(\\d+)?',
        beforeEnter: (to, from, next) => beforeEnter(to, from, next),
        component: LostYearsClaims,
        meta: {
            claimStore: 'lost',
        },
        children: [
            {
                name: 'lost::step-1',
                path: 'claimant-details',
                component: ClaimantDetails,
                meta: {
                    step: 1,
                    name: 'Claimant Details',
                    store: 'claimant',
                },
                beforeEnter: (to, from, next) => beforeEnter(to, from, next),
            },
            {
                name: 'lost::step-2',
                path: 'claim-info',
                component: ClaimInfo,
                meta: {
                    step: 2,
                    name: 'Claim Info',
                    store: 'claimInfo',
                },
                beforeEnter: (to, from, next) => beforeEnter(to, from, next),
            },
            {
                name: 'lost::step-3',
                path: 'income-information',
                component: IncomeInformation,
                meta: {
                    step: 3,
                    name: 'Income Information',
                    store: 'incomeInformation',
                },
                beforeEnter: (to, from, next) => beforeEnter(to, from, next),
            },
            {
                name: 'lost::step-4',
                path: 'loss-of-income',
                component: LossOfIncome,
                meta: {
                    step: 4,
                    name: 'Loss of Income',
                    store: 'lossOfIncome',
                },
                beforeEnter: (to, from, next) => beforeEnter(to, from, next),
            },
            {
                name: 'lost::step-5',
                path: 'other-heads-of-loss',
                component: HeadsOfLoss,
                meta: {
                    step: 5,
                    name: 'Other Heads of Loss',
                    store: 'headsOfLoss',
                },
                beforeEnter: (to, from, next) => beforeEnter(to, from, next),
            },
            {
                name: 'lost::step-6',
                path: 'cru-benefits',
                component: CruBenefits,
                meta: {
                    step: 6,
                    name: 'CRU Benefits',
                    store: 'cruBenefits',
                },
                beforeEnter: (to, from, next) => beforeEnter(to, from, next),
            },
            {
                name: 'lost::step-7',
                path: 'interim-payments',
                component: InterimPayments,
                meta: {
                    step: 7,
                    name: 'Interim Payments and Interest',
                    store: 'interimPayments',
                },
                beforeEnter: (to, from, next) => beforeEnter(to, from, next),
            },
            {
                name: 'lost::step-8',
                path: 'calculate-loss',
                component: CalculateLoss,
                meta: {
                    step: 8,
                    name: 'Calculate Loss and Generate Schedule',
                    store: 'calculateLoss',
                },
                beforeEnter: (to, from, next) => beforeEnter(to, from, next),
            },
            {
                name: 'lost::documents',
                path: 'documents',
                component: Documents,
                meta: {
                    step: 10,
                    name: 'Documents',
                    store: 'documents'
                },
                children: [
                    {
                        name: 'lost::documents.list',
                        path: 'list',
                        component: DocumentList,
                        meta: {
                            step: 10,
                            name: 'List',
                        },
                    },
                    {
                        name: 'lost::documents.editor',
                        path: 'editor/:document_id(\\d+)',
                        component: DocumentEditor,
                        meta: {
                            step: 10,
                            name: 'Editor',
                        },
                    },
                ],
            },
        ],
    },
];



// WEBPACK FOOTER //
// ./src/pages/lost-years-claims/routes.js